export default {
  independentMarketing: {
    common: {
      requestFailed: 'Solicitud de interfaz fallida',
      hintSelect: 'Ingresar',
      hintInput: 'Introducir',
      submit: 'Presentar',
      cancel: 'Cancelar',
      confirm: 'Aceptar',
    },
    agreement: {
      title: 'Acuerdo de registro de distribuidor independiente de Autel',
      nextBtn: 'Próximo',
      getAgreementFailed: 'No se pudo obtener el contenido del acuerdo.',
    },
    successPage: {
      title:
        'La información de su solicitud se envió con éxito y los resultados de la revisión se enviarán a su correo electrónico $1 dentro de los 15 días hábiles. Por favor revisa tu bandeja de entrada para más información.',
      subTitle: 'Regrese a la página de inicio después de $1 segundo(s).',
    },
    applyTitle:
      'Está solicitando convertirse en distribuidor independiente de Autel. Por favor complete la siguiente información con precisión:',
    companyName: 'Nombre de la empresa',
    companyTax: 'VAT ID',
    userCountry: 'País',
    legalPerson: 'Consejero legal',
    contactEmail: 'Email de contacto',
    contactEmailTips:
      'Esta dirección de correo electrónico será su contacto en el correo electrónico del resultado de la revisión. Una vez aprobada la revisión, también se utilizará como nombre de cuenta de inicio de sesión para el sistema de gestión de distribuidores independientes.',
    corporateIdentity: 'identificación del asesor legal',
    uploadTips: 'JPG, JPEG, PNG, PDF (no mayor a 20 MB)',
    businessLicense: 'Licencia de negocios',
    emailErrorTips: 'Introducir correo válido.',
    uploadPic: 'Subir imágenes',
    picMaxLimit: 'El tamaño máximo de imagen es 20 MB. Por favor seleccione nuevamente.',
  },
};
